module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"emptyVacancies":"У работодателя в настоящий момент нет активных вакансий"}}')
  delete Component.options._Ctor
}
